// extracted by mini-css-extract-plugin
export default {"glitchText":"Glitch_glitchText__qPN4q","small":"Glitch_small__o1AAt","glitchImage":"Glitch_glitchImage__7cMQA"};